<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
      <!--== Start Preloader Content ==-->
      <div class="preloader-wrap" v-if="showLoader">
        <div class="preloader">
          <div class="text-center text-danger my-2">
              <img class="img-loading2" src="../../assets/img/logo-daring.png" alt="Logo"/><br>
              <b-spinner class="align-middle"></b-spinner>
          </div>
        </div>
      </div>
      <loading :active.sync="overlay.isLoading" 
        :can-cancel="false"
        :is-full-page="overlay.fullPage"
        :color="'#ca062a'"
        :loader="'bars'"
      ></loading>
      <!--== End Preloader Content ==-->
    <sidebar></sidebar>
    <div class="main-content" :data="sidebarBackground">
      <base-header type="gradient-success" class="pb-6 pb-8 pt-md-8">
      </base-header>
      <dashboard-navbar></dashboard-navbar>
      <main-content></main-content>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './Navbar';
  import Sidebar from './Sidebar';
  import MainContent from './Content';
  import { EventBus } from '@/eventBus.js'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    components: {
      DashboardNavbar,
      MainContent,
      Sidebar,
      Loading
    },
    data() {
      return {
        sidebarBackground: 'red', //vue|blue|orange|green|red|primary
        showLoader: false,
        overlay: {
          isLoading: false,
          fullPage: true,
        }
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      async getUser () {
        // this.showLoader = true
        await this.$store.dispatch('getUser')
          .then(() => {
            // this.showLoader = false
            // this.$swal.fire('Success', res.data.message, 'success')
          })
          .catch((err)=> {
            // this.showLoader = false
            this.$swal.fire('Failed', err.response.data.message, 'error')
          })
      }
    },
    async created() {
      await this.getUser()
			EventBus.$on('showLoader', (val) => {
				if (val) {
          this.showLoader = true
				}
			})
      EventBus.$on('hideLoader', (val) => {
        if (val) {
          setTimeout(() => this.showLoader = false, 1000);
        }
      })
			EventBus.$on('showLoaderOverlay', (val) => {
				if (val) {
          this.overlay.isLoading = true
				}
			})
      EventBus.$on('hideLoaderOverlay', (val) => {
        if (val) {
          setTimeout(() => this.overlay.isLoading = false, 1000);
        }
      })
    }
  };
</script>
<style lang="scss">
</style>
